import React from 'react'

const COLORS = {
  BLACK: '#1F2937',
  BLUE: '#3362FF',
}

export const AccountIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5.121 17.804A13.937 13.937 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SettingIcon = ({ color = COLORS.BLACK }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>nav-operations</title>
    <g
      id="nav-operations"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g id="icon" transform="translate(3.000000, 3.000000)" stroke={color} strokeWidth="2">
        <path
          d="M7.32463,1.31731 C7.75103,-0.439103 10.249,-0.439103 10.6754,1.31731 C10.9508,2.45193 12.2507,2.99038 13.2478,2.38285 C14.7913,1.44239 16.5576,3.2087 15.6172,4.75218 C15.0096,5.74925 15.5481,7.04918 16.6827,7.32463 C18.4391,7.75103 18.4391,10.249 16.6827,10.6754 C15.5481,10.9508 15.0096,12.2507 15.6172,13.2478 C16.5576,14.7913 14.7913,16.5576 13.2478,15.6172 C12.2507,15.0096 10.9508,15.5481 10.6754,16.6827 C10.249,18.4391 7.75103,18.4391 7.32463,16.6827 C7.04918,15.5481 5.74926,15.0096 4.75219,15.6172 C3.2087,16.5576 1.44239,14.7913 2.38285,13.2478 C2.99038,12.2507 2.45193,10.9508 1.31731,10.6754 C-0.439103,10.249 -0.439103,7.75103 1.31731,7.32463 C2.45193,7.04918 2.99037,5.74926 2.38285,4.75218 C1.44239,3.2087 3.2087,1.44239 4.75219,2.38285 C5.74926,2.99037 7.04918,2.45193 7.32463,1.31731 Z"
          id="Path"
        />
        <path
          d="M12,9 C12,10.6569 10.6569,12 9,12 C7.34315,12 6,10.6569 6,9 C6,7.34315 7.34315,6 9,6 C10.6569,6 12,7.34315 12,9 Z"
          id="Path"
        />
      </g>
    </g>
  </svg>
)

export const SecurityIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9.3 12L11.5 14L14.7 10M13.6 20.7C12.6 21.1 11.4 21.2 10.4 20.7C7.7 19.6 3.9 16.8 3.5 12C3 5.5 3 6 3 6L12 3L21 6C21 6 21 5.5 20.5 12C20.2 16.5 16.3 19.5 13.6 20.7Z"
      stroke={color}
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CompanyIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AboutIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ZeroDarkWebIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 4.70248L11.8438 2L20.4986 4.70248V5.20504C13.0657 5.58854 5.92024 7.87706 3.50417 8.99571L3.5 8.99848V4.70386V4.70248ZM3.50278 10.8966C3.53471 12.5455 3.93462 14.139 4.64416 15.5761C6.96721 13.2502 13.3406 8.06258 13.3406 8.06258L3.50278 10.8966ZM6.49926 18.2481C7.16021 18.9528 7.91836 19.5758 8.76121 20.0964L11.8438 22L15.0833 20.0714C17.0758 18.8863 18.6102 17.1322 19.528 15.0887C16.1483 15.5636 9.83872 17.2956 6.49788 18.2495L6.49926 18.2481ZM20.4861 11.1056C20.4944 10.9243 20.5 10.7429 20.5 10.5615V6.73764C17.6937 8.15257 12.084 11.0336 10.4552 12.9165C12.3645 12.5206 18.4755 11.4545 20.4861 11.1042V11.1056Z"
      fill={color}
    />
  </svg>
)

// 패스키 탭 지문 아이콘 (Figma 956:891 — lucide fingerprint 계열, stroke 기반 색상 전환)
export const PasskeyIcon = ({ color = COLORS.BLACK }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 13.02 9.9 14.51 9.74 16" />
      <path d="M14 13.12C14 15.5 14 19.5 13 22" />
      <path d="M17.29 21.02C17.41 20.42 17.72 18.72 17.79 18" />
      <path d="M2 12C2 9.90117 2.66037 7.85555 3.88758 6.1529C5.11478 4.45024 6.8466 3.17687 8.83772 2.51317C10.8288 1.84946 12.9783 1.82906 14.9817 2.45486C16.985 3.08067 18.7407 4.32094 20 6" />
      <path d="M2 16H2.01" />
      <path d="M21.8 16C22 14 21.931 10.646 21.8 10" />
      <path d="M5 19.5C5.5 18 6 15 6 12C5.99899 11.3189 6.11397 10.6425 6.34 10" />
      <path d="M8.65 22C8.86 21.34 9.1 20.68 9.22 20" />
      <path d="M9 6.8C9.9124 6.27323 10.9474 5.99598 12.001 5.99615C13.0545 5.99632 14.0894 6.2739 15.0017 6.80096C15.9139 7.32803 16.6713 8.086 17.1976 8.99865C17.7239 9.9113 18.0007 10.9465 18 12V14" />
    </g>
  </svg>
)

const icon = {
  AccountIcon,
  SettingIcon,
  SecurityIcon,
  CompanyIcon,
  AboutIcon,
}

export default icon
